const PLN_FORMATTER = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatGrosz(amount: number | null): string {
  return amount === null ? '—' : PLN_FORMATTER.format(amount / 100)
}
